var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',{staticClass:"mt-16"},[_c('v-row',{attrs:{"align":"center","justify":"center"}},[_c('v-col',{attrs:{"align":"center"}},[_c('div',{staticClass:"app-title"},[_vm._v("Assets by")]),_c('img',{staticStyle:{"max-width":"640px"},attrs:{"src":"/img/carnetix.svg","alt":"CarNetiX"}})])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }